<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH SẢN PHẨM</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <el-button
              type="primary"
              @click="fn_addSlide()"
              icon="el-icon-circle-plus-outline"
              >thêm mới sản phẩm</el-button
            >
          </div>
        </div>

        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Mã sản phẩm">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['ma_sp']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Tên sản phẩm">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['ten']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Đại lý bán">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['dai_ly_ban']
                          "
                          placeholder="Chọn"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in optionsChietKhau"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Sản phẩm">
                        <el-select
                          v-model="mData.tableRules.dataSearch.value['loai']"
                          placeholder="Chọn"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in optionsLoaiSP"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Loại sản phẩm">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['phu_kien']
                          "
                          placeholder="Chọn"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in optionsPhuKien"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Hiệu lực">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value['hieu_luc']
                          "
                          placeholder="Chọn"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="item in optionsEnable"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>

          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
            >
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ma_sp"
                label="Mã sản phẩm"
                min-width="120"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="ten"
                label="Tên sản phẩm"
                min-width="140"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="gia_niem_yet"
                label="Giá niêm yết (VNĐ)"
                min-width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <div>
                    {{
                      `${scope.row.gia_niem_yet}`.replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        "."
                      )
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="Đại lý bán"
                min-width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.dai_ly_ban"
                    @change="updateSanPham(scope.row, 'dai_ly_ban')"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                prop="loai"
                label="Sản phẩm"
                min-width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.loai === 'khoi_tao'">Khởi tạo</div>
                  <div v-if="scope.row.loai === 'gia_han'">Gia hạn</div>
                  <div v-if="scope.row.loai === 'nang_cap'">Nâng cấp</div>
                  <div v-if="scope.row.loai === 'khac'">Khác</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="phu_kien"
                label="Loại sản phẩm"
                min-width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.phu_kien">Phụ kiện</div>
                  <div v-else>Sản phẩm</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="name_san_pham_cha"
                label="Sản phẩm cha"
                min-width="120"
                align="center"
              >
                <template slot-scope="slotData">
                  <el-tooltip effect="dark" placement="top">
                    <div slot="content">
                      {{ slotData.row.name_san_pham_cha }}
                    </div>
                    <span>{{ slotData.row.name_san_pham_cha }}</span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="Hiệu lực" min-width="80" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.hieu_luc"
                    @change="updateSanPham(scope.row, 'hieu_luc')"
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" align="center" width="110px">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.row)"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('update', scope.row)"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormSanPham";
import mushroom from "viettoc-api";

export default {
  data() {
    return {
      loading: false,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
      optionsLoaiSP: [
        {
          value: "khoi_tao",
          label: "Khởi tạo",
        },
        {
          value: "gia_han",
          label: "Gia hạn",
        },
        {
          value: "nang_cap",
          label: "Nâng cấp",
        },
        {
          value: "khac",
          label: "Khác",
        },
      ],
      optionsPhuKien: [
        {
          value: "true",
          label: "Phụ kiện",
        },
        {
          value: "false",
          label: "Sản phẩm",
        },
      ],
      optionsChietKhau: [
        {
          value: "true",
          label: "Có cho bán",
        },
        {
          value: "false",
          label: "Không cho bán",
        },
      ],
      optionsEnable: [
        {
          value: "true",
          label: "Hiệu lực",
        },
        {
          value: "false",
          label: "Hết hiệu lực",
        },
      ],
      listSanPham: [],
    };
  },
  components: {
    Circle4,
  },
  methods: {
    // lấy data
    async getData() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachSanPham",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      try {
        const response = await mushroom.prd_san_pham.listAsync(dataFilter);
        let resData = await this.fn_changeData(response.result);
        this.mData.tableRules.data = resData;
        this.mData.tableRules.total = response.meta.total;
        this.mData.tableRules.page =
          response.meta.offset / response.meta.limit + 1;
        this.loading = false;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    async getListSanPham() {
      try {
        const response = await mushroom.prd_san_pham.getAllAsync();
        this.listSanPham = response.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },

    // custom data
    fn_changeData(data) {
      data.forEach((sanPham) => {
        if (sanPham.san_pham_cha_ids && sanPham.san_pham_cha_ids.length > 0) {
          let listCha = "";
          sanPham.san_pham_cha_ids.forEach((itemId, index) => {
            if (index === 0) {
              listCha = this.listSanPham.find((item) => item.id === itemId).ten;
            }
            if (index !== 0) {
              listCha =
                listCha +
                ", " +
                this.listSanPham.find((item) => item.id === itemId).ten;
            }
          });
          sanPham.name_san_pham_cha = listCha;
        }
      });
      return data;
    },
    // tìm kiếm
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["ma_sp"]) {
        this.mData.tableRules.dataSearch.value["ma_sp"] =
          this.mData.tableRules.dataSearch.value["ma_sp"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["ten"]) {
        this.mData.tableRules.dataSearch.value["ten"] =
          this.mData.tableRules.dataSearch.value["ten"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["loai"]) {
        this.mData.tableRules.dataSearch.value["loai"] =
          this.mData.tableRules.dataSearch.value["loai"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["phu_kien"]) {
        this.mData.tableRules.dataSearch.value["phu_kien"] =
          this.mData.tableRules.dataSearch.value["phu_kien"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["hieu_luc"]) {
        this.mData.tableRules.dataSearch.value["hieu_luc"] =
          this.mData.tableRules.dataSearch.value["hieu_luc"].trim();
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.page = 1;
          this.getData(false);
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    // update
    async updateSanPham(row, text) {
      const prd_san_pham_object = {
        id: row.id,
      };
      if (text === "hieu_luc") {
        prd_san_pham_object.hieu_luc = row.hieu_luc;
      } else if (text === "dai_ly_ban") {
        prd_san_pham_object.dai_ly_ban = row.dai_ly_ban;
      }
      try {
        const response = await mushroom.prd_san_pham.partialUpdateAsync(
          prd_san_pham_object
        );
        if (response.result == prd_san_pham_object.id) {
          window.toastr.success("Cập nhật trạng thái Sản phẩm thành công");
        } else window.toastr.warning("Dữ liệu không thay đổi");
      } catch (e) {
        this.loading = false;
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },

    // show form tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
    },
    // thêm cấp
    fn_addSlide() {
      this.$router.push({
        name: "ThemMoiSanPham",
      });
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },

    // chuyển trang
    fn_handle(type, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietSanPham",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatSanPham",
          params: { id: row.id },
        });
      }
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getData();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
  },

  async created() {
    this.fn_hashUrl();
    await this.getListSanPham();
    await this.getData();
  },
};
</script>
